module.exports = __webpack_public_path__ + "static/img/RisScan.f34aa06c.png";